function initializeDetailCardHoverEventListeners() {
  const cards = document.querySelectorAll(".rbsv4-detail-cards__card");
  if (cards.length === 0) {
    return;
  }

  cards.forEach((card) => card.addEventListener("mouseenter", handleCardToggleEvent));
}

function intializeMobileDetailCardEventListeners() {
  const cardButtons = document.querySelectorAll(".rbsv4-detail-cards__card-content-right");
  if (cardButtons.length === 0) {
    return;
  }

  cardButtons.forEach((cardButton) => cardButton.addEventListener("click", handleCardToggleEvent));
}

function handleCardToggleEvent(event) {
  const hoveredCard = event?.target?.closest(".rbsv4-detail-cards__card");
  if (!hoveredCard) {
    return;
  }

  const hoveredCardContainer = hoveredCard.querySelector(".rbsv4-detail-cards__card-content-container");
  if (hoveredCardContainer.classList.contains("active")) {
    return;
  }

  const activeCard = document.querySelector(".rbsv4-detail-cards__card-content-container.active");
  if (activeCard) {
    activeCard.classList.remove("active");
  }

  hoveredCardContainer.classList.toggle("active");
}

function renderActiveContentForFirstCard() {
  const card = document.querySelector(".rbsv4-detail-cards__card-content-container");
  if (card) {
    card.classList.toggle("active");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const isSmallScreen = window.innerWidth <= 990;
  if (isSmallScreen) {
    intializeMobileDetailCardEventListeners();
    return;
  }

  initializeDetailCardHoverEventListeners();
  renderActiveContentForFirstCard();
});
